<template>
    <div class="view view-video" >
        <top-bar v-if="isPortalReady" />
        <div class="video-player-wrapper">
            <div class="container">
                <div v-if="hasUserVideo" id="video-player"></div>
                <div v-else>
                    <div class="video-info">
                        <img v-if="video" :src="video.imagen" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="video-info-wrapper" v-if="userVideosCount>0">
            <div class="container">
                <div class="row">
                    <div class="col-md-10 offset-md-1">
                        <div class="video-info"
                            v-if="video.id != 0">
                            <h1>{{ video.titulo }}</h1>
                            <div class="video-info-description"
                                v-html="contenido.descripcion"></div>
                            <div class="row video-info-nav" v-if="tieneCurso ">
                                <div class="col col-sm-5 video-info-nav-link d-flex align-items-center" >
                                    <button class="btn video-info-nav-prev bg-aqua color-white w-100 h-100"
                                        v-if="previousVideo.id != 0"
                                        @click="goToVideo(previousVideo,previousContenido)">
                                            <span>Anterior:</span> <span>{{ quitarTituloContenido(previousVideo) }}</span>
                                    </button>
                                </div>
                            <div class="col col-sm-2" ></div>
                                <div class="col col-sm-5 video-info-nav-link video-info-nav-next d-flex align-items-center" >
                                    <button class="btn video-info-nav-next bg-aqua color-white w-100 h-100"
                                        v-if="nextVideo.id != 0"
                                        @click="goToVideo(nextVideo,nextContenido)">
                                        <span> Siguiente:</span> <span>{{ quitarTituloContenido(nextVideo) }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

         <contenido-list
            v-if="curso.id != 0"
            :contenidos="curso.contenidos"
            :tieneCurso="tieneCurso"
            :registrado="this.user.id"
            :NoAvailable="false"
             />
        <div v-else>
            <div class="curso-loading">
                <spinner />
            </div>
        </div>

        <b-modal v-model="isPopDispositivosVisible"
            :busy="true"
            centered
            hide-footer
            title="Dispositivos">
            <dispositivos
                :dispositivos="dispositivos"
                @deshabilitar="deshabilitar">
            </dispositivos>
        </b-modal>
        <site-footer v-if="isPortalReady"  :verFooter="true" />
    </div>
</template>

<script>
import TopBar from "../components/TopBar";
import SiteFooter from "../components/SiteFooter";
import { mapState } from "vuex";
import {
	getPreviousVideo,
	getNextVideo,
	getProgresoVideo,
	getDuracionVideo,
    quitarTituloContenido,
    getProductoDeCategoria,
    userTieneProducto,
    getNextContenido,
    getPreviousContenido
} from "../utilities/data";
import { wait } from "../utilities/util";
import bModal from "bootstrap-vue/es/components/modal/modal";
import bModalDirective from "bootstrap-vue/es/directives/modal/modal";
import Dispositivos from "../components/Dispositivos";
import ContenidoList from "../components/ContenidoList";


export default {
	name: "Video",
	components: {
		TopBar,
		SiteFooter,
		Dispositivos,
        bModal,
        ContenidoList,
	},
	directives: {
		"b-modal": bModalDirective
	},
	data() {
		return {
			isLoading: true,
			isVideoReady: false,
			isLoadingContenidos: false,
			isPopDispositivosVisible: false,
			routeVideoId: 0,
			video: {
				id: 0,
				video: ""
			},
			previousVideo: {
				id: 0
			},
			nextVideo: {
				id: 0
            },
            nextContenido: {
				id: 0
            },
            previousContenido: {
				id: 0
            }
            ,
			contenido: {
				id: 0
			},
			categoria: {
				id: 0
			},
			isEmbedded: false,
			lastPing: 0,
			loadedVideoId: 0,
			hasUserVideo: false,
			dispositivos: [],
            video_id_video:""
		};
	},
	computed: {
         tieneLogin() {
			if (this.user.id == 0){
                return false;
            }else{
                return true;
            }
		},
		userVideosCount() {
			return this.user.videos.length;
		},
		portalCategorias() {
			return this.portal.categorias;
		},
		categoriaContenidosLoaded() {
			return this.categoria.id != 0
				? this.categoria.contenidosLoaded
				: false;
        },
        curso() {
			// Devolver el curso y reemplazar los videos del portal por los del usuario (si esta logueado)
			if (this.portal.categorias) {
				return (
					this.portal.categorias.find(
						cat => cat.guid == this.$route.params.guid_categoria
					) || { id: 0 }
				);
			}
			return { id: 0, contenidos: [] };
		},
        productoAsociado() {
			return this.portal.productos_portal && this.curso.id != 0
				? getProductoDeCategoria(this.portal, this.curso.id)
				: false;
		},
		tieneCurso() {
			if (this.user.all_access_active == 1) return true;
			if (!this.productoAsociado) return false;
			if (this.user.id == 0) return false;
			return userTieneProducto(this.user, this.productoAsociado.id);
		},
		videoInCategoriaContenidos() {
			if (this.categoria.id == 0) return false;
			if (
				!this.categoria.contenidosLoaded ||
				this.categoria.contenidos.length == 0
			)
				return false;

			let found = false;
			this.categoria.contenidos.forEach(contenido => {
				contenido.contenidos_videos.forEach(vid => {
					if (vid.id == this.routeVideoId && !found) found = true;
				});
			});
			// console.log("elfilter", found);
			return found;
		},
		...mapState(["isPortalReady", "portal", "user", "site"])
	},
	watch: {
		categoriaContenidosLoaded(val, old) {
			if (val) {
				this.previousVideo = getPreviousVideo(
					this.categoria,
					this.video.id
				) || { id: 0 };
				this.nextVideo = getNextVideo(
					this.categoria,
					this.video.id
				) || { id: 0 };
			}
		},
		video() {
			this.hasUserVideo = this.video.id != 0;
		}
	},
	methods: {
        tieneVideo(video) {
            return this.user.videos.find(v => v.id == video.id) ? true : false;
		},
		deshabilitar(dispositivo) {
			this.$api
				.deshabilitarDispositivo(dispositivo.id)
				.then(response => {
					if (parseInt(response.data.response) == 200) {
						this.dispositivos = this.dispositivos.filter(
							d => d.id != dispositivo.id
						);
						this.isPopDispositivosVisible = false;
						this.getPlayer().play();
					}
				})
				.catch(error => {
					// console.log("error deshabilitar", error);
				});
		},
		loadPlayer() {
			// Esperar que el player este disponible
			if (
				typeof window.jwplayer === "undefined" ||
				document.querySelector("#video-player") == null
			) {
				// console.log("espera");
				return wait(this.loadPlayer, 200);
			}

			let video = this.getVideoFromCompras(this.video);

            if(typeof video !=="undefined"){
            this.video_id_video=video.video;
            }

            if(this.contenido.gratis==1){
                 this.video_id_video=this.contenido.contenidos_videos[0].video;
                    console.log("entroooooooooooooooooooooooooo",this.video_id_video)
            }

			console.log("loading player for ",this.video_id_video);

			this.$api
				.getPlayerEmbed("media", ""+String(this.video_id_video)+"")
				.then(response => {
					let player = JSON.parse(response.data.player);
                	console.log(player)
					let sources = player[0].playlist[0].sources;
					// Buscar el tamaño más grande para calcular el alto.
					let ref = sources.reduce(
						(prev, item) => {
							if (
								item.hasOwnProperty("width") &&
								item.hasOwnProperty("height")
							)
								if (item.width > prev.width) return item;

							return prev;
						},
						{
							width: 0,
							height: 0
						}
					);
					let width =
						document.querySelector(
							".video-player-wrapper .container"
						).clientWidth - 30;
					let height = (width * ref.height) / ref.width;
					this.player = window
						.jwplayer("video-player")
						.setup({
							file: sources[0].file,
							image: player[0].playlist[0].image,
							width,
							height
						})
						.seek(getProgresoVideo(this.user, this.video.id))
						.on("time", e => {
							let seconds = parseInt(e.position);
							if (
								seconds % 10 === 0 &&
								seconds > 0 &&
								seconds != this.lastPing
							) {
								this.lastPing = seconds;
								this.ping(parseInt(e.position));
							}
						})
						.on("play", e => {
							this.ping(parseInt(this.getPlayer().getPosition()));
						})
						.on("complete", e => {
							this.ping(
								Math.floor(parseFloat(video.video_duracion))
							);
						});
					this.isEmbedded = true;
					this.loadedVideoId = parseInt(this.video.id);
					this.hasUserVideo = true;
				})
				.catch(error => console.log(error));
		},

		/**
		 * Pasar por los videos del usuario y buscar el de la url.
		 */
		loadFromUserVideos() {
			if (this.user.videos.length == 0) {
				// Esperar
				return wait(loadFromUserVideos, 500);
			}
			let video = this.user.videos.find(
				v => parseInt(v.id) == parseInt(this.routeVideoId)
			);

			if (video) {
				// Lo tiene, asignar y cargar player.
				this.video = Object.assign(this.video, video);
				this.hasUserVideo = true;
				this.previousVideo = getPreviousVideo(this.categoria, video.id)
					? {
							...getPreviousVideo(this.categoria, video.id)
					  }
					: { id: 0 };
				this.nextVideo = getNextVideo(this.categoria, video.id)
					? {
							...getNextVideo(this.categoria, video.id)
					  }
					: { id: 0 };
				this.nextContenido = getNextContenido(this.categoria, video.id)
					? {
							...getNextContenido(this.categoria, video.id)
					  }
					: { id: 0 };
				this.previousContenido = getPreviousContenido(this.categoria, video.id)
					? {
							...getPreviousContenido(this.categoria, video.id)
					  }
					: { id: 0 };
				this.$nextTick(() => {
					this.loadPlayer();
				});
			} else {
				// Buscar en contenidos de categoria

				// No tiene acceso al video, mandar al home
				// console.log("home en loaduservideos");
				this.$router.push({ name: "home" });
			}
			this.isLoading = false;
		},

		getFromCategoriaContenidos() {
			let video = false;
			this.categoria.contenidos.forEach(contenido => {
				contenido.contenidos_videos.forEach(vid => {
					if (vid.id == this.routeVideoId && !video)
						video = { ...vid };
				});
			});
			return video;
		},

		loadAndPlay(video) {
			console.log("loadandplay", video);
			this.video = { ...video };
			this.previousVideo = {
				...(getPreviousVideo(this.categoria, video.id) || { id: 0 })
			};
			this.nextVideo = {
				...(getNextVideo(this.categoria, video.id) || { id: 0 })
            };
			this.nextContenido = {
				...(getNextContenido(this.categoria, video.id) || { id: 0 })
            };
			this.previousContenido = {
				...(getPreviousContenido(this.categoria, video.id) || { id: 0 })
            };
			this.hasUserVideo = true;
			this.$nextTick(() => {
				this.loadPlayer();
			});
		},

		/**
		 * Revisa si cargó la info del portal y del usuario (o espera) y cuando esté todo, busca
		 * el video en los videos del usuario.
		 */
		loadFullVideo() {
			console.log("loadfullvideo");
			// Esperar cualquier carga previa
			if (
				this.site.isLoadingUser ||
				this.site.isLoadingUserCompras ||
				this.site.isLoadingUserVideos ||
				this.site.isLoadingCookie ||
				this.isLoadingContenidos ||
				!this.site.didLoadUser
			)
				// Aún está cargando.
				return wait(this.loadFullVideo, 300);

			// No esta registrado, home.
			if (this.user.id == 0) {
				// console.log("user id 0, al home");
				this.$router.push({ name: "home" });
			}

			// Buscar el curso (categoría), si no existe, 404
			if (!this.loadCategoria()) this.$router.push({ name: "error404" });

			// Cargar contenido
			if (!this.loadContenido()) return wait(this.loadFullVideo, 300);

			/* console.log(
				"log categoria",
				this.categoria,
				this.videoInCategoriaContenidos
			);*/

			// Si está en los contenidos de la categoría, cargar de ahí.
			let videoFromContenidos = this.getFromCategoriaContenidos();
			console.log({ videoFromContenidos });
			if (videoFromContenidos) {
				this.loadAndPlay(videoFromContenidos);
			} else {
				// Si no está en los videos no existe, lo va a mandar al home.
				this.loadFromUserVideos();
			}
		},

		/**
		 * Revisa que la categoría del slug esté cargada y devuelve un booleano.
		 */
		loadCategoria() {
			// Buscar la categoria (curso)
			/* console.log("cats actuales", this.portal.categorias, {
				...this.$route
			});*/
			let categoria = this.portal.categorias.find(
				cat =>
					cat.guid.toLowerCase() ===
					this.$route.params.guid_categoria.toLowerCase()
			);
			if (categoria) {
				console.log("found cat", categoria);
				this.categoria = { ...categoria };
				return true;
			} else return false;
		},

		/**
		 * Revisa que el contenido del slug esté cargado, si la categoría no
		 * tiene contenidos cargados, los pide al api.
		 */
		loadContenido() {
			 console.log(
				"load contenido",
				"videoid",
				this.routeVideoId,
				this.categoria
			);
			if (this.categoria.id == 0) {
				let cat = this.portal.categorias.find(
					c =>
						c.guid.toLowerCase() ==
						this.$route.params.guid_categoria.toLowerCase()
				);
				if (cat) {
					this.categoria = { cat };
				} else {
					 console.log("else categoria", this.categoria);
				}
			}

			if (!this.categoria.contenidosLoaded) {
				// No se han cargado los contenidos de este curso, pedirlos al api.
				this.isLoadingContenidos = true;
				this.$store
					.dispatch("getCategoriaContenido", this.categoria.id)
					.then(response => {
						this.isLoadingContenidos = false;
						this.loadCategoria();
					})
					.catch(error => {
						this.isLoading = false;
						// console.log({ error });
						this.isLoadingContenidos = false;
					});
				return false;
			}
			this.isLoadingContenidos = false;

			// Pasar por los contenidos del curso y buscar el video.
			let found = false;
			this.categoria.contenidos.forEach(contenido => {
				contenido.contenidos_videos.forEach(video => {
					if (video.id == this.routeVideoId && !found) {
						// Asignar el video encontrado o el del usuario (preferir el del usuario)
						this.contenido = { ...contenido };
						this.isLoading = false;
                        found = true;
                            if(!this.tieneCurso && this.contenido.gratis=="0" || !this.tieneVideo(video) && this.contenido.gratis=="0"){
                                this.$router.push({
                                        name: "curso",
                                        params: {
                                            guid: this.$route.params.guid_categoria
                                        }
                                    });
                                }

                                 let postData = {
                                    event: "Clase "+this.portal.nombre,
                                    curso: "Curso "+this.curso.autor,
                                    clase: this.contenido.titulo,
                                };
                                this.$store
                                        .dispatch("eventKlaviyo", postData)
                                        .then(response => {});


						return true;
					}
				});
			});


            this.$api.getCategoriaContenido(this.categoria.id)
                .then(response => {
                    console.log('categoria contenido response', response)

                response.data.contenidos.forEach(contenido => {

                    if(contenido.id==this.contenido.id && contenido.gratis==1){
                       this.contenido=contenido;
                    console.log("actualizo",this.contenido)
                    }
                });

                })
                .catch(error => {
                    console.log(error)
                })

			return found;
		},

		/**
		 * Avisar al api del progreso del video y levantar ventana de dispositivos si aplica.
		 */
		ping(progreso) {
			this.$store
				.dispatch("videoProgreso", {
					id_contenido_video: this.video.id,
					progreso: progreso
				})
				.then(response => {
					if (
						response.message == "LIMITE DE REPRODUCCIONES ALCANZADO"
					) {
						this.getPlayer().pause();
						this.dispositivos = response.data;
						this.isPopDispositivosVisible = true;
					} else {
						// Actualizar el progreso local.
						this.$store.dispatch("updateProgreso", {
							video: this.video,
							progreso
						});
					}
				})
				.catch(error => {
					// console.log("error progreso");
				});
		},

		/**
		 * Devuelve la instancia del player.
		 */
		getPlayer() {
			return window.jwplayer("video-player");
		},
		volverAlCurso() {
			this.$router.push({
				name: "curso",
				params: {
					guid: this.$route.params.guid_categoria
				}
			});
        },
        numeroIntervalo(posicion_video_contenido){

            if(posicion_video_contenido>=1 && posicion_video_contenido<=9){
                return "0"+posicion_video_contenido;
            }else{
                return posicion_video_contenido;
            }
        }
        ,
		goToVideo(video,contenido) {
			console.log("pushing", video,this.contenido);
			/*this.$router.push({
				name: "video",
				params: {
					id_video: video.id,
					guid_categoria: this.contenido.contenidos_categorias[0]
						.categorias_contenidos[0].guid
				}
            });*/

            this.$router.push({
				name: "video",
				params: {
					id_video: video.id,
					id_p_video:  this.numeroIntervalo(video.posicion),
					id_p_contenido: this.numeroIntervalo(contenido.posicion),
					guid_categoria:
						contenido.contenidos_categorias[0]
							.categorias_contenidos[0].guid,
					guid_contenido: contenido.guid
				}
            });

		},
		getVideoFromCompras(video) {
			return this.user.videos.find(v => v.id == video.id);
		}
        ,
		quitarTituloContenido(video) {
			// Buscar contenido
			if (!("contenidos" in this.categoria)) return "";
			let titulo = "";
			this.categoria.contenidos.forEach(contenido => {
				contenido.contenidos_videos.forEach(v => {
					if (v.id == video.id && titulo == "") {
						console.log("conseguido", contenido, video);
						titulo = quitarTituloContenido(contenido, video);
					}
				});
			});
			return titulo;
		}
	},
	beforeRouteEnter(to, from, next) {
		console.log("beforeRouteEnter");
		next(vm => {
			// console.log("abriendo vista video", to);
			if (vm.isPortalReady) {
				// Cargar todo lo que corresponde al video (categoria, contenido y video)
				// console.log("bre loadfull");
				vm.routeVideoId = parseInt(to.params.id_video);
				vm.loadFullVideo();
				window.scroll(0, 0);
			}
		});
	},
	beforeRouteUpdate(to, from, next) {
		if (
			this.categoria.guid.toLowerCase() !=
			to.params.guid_categoria.toLowerCase()
		) {
			console.log("wipecatcon");
			this.categoria = { id: 0 };
			this.contenido = { id: 0 };
		}

		this.routeVideoId = parseInt(to.params.id_video);
		this.previousVideo = { id: 0 };
		this.nextVideo = { id: 0 };
		this.video = { id: 0 };
		this.isLoading = true;
		this.hasUserVideo = false;
		this.loadFullVideo();
		window.scroll(0, 0);
        next();
	},
	created() {
        this.player = null;
	},
	mounted() {
        this.playerHeight = 300;



	}
};
</script>
